import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import Dialog from 'components/ReusableComponents/Dialog'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import SearchGuestDialog from 'components/ReusableComponents/SearchGuestDialog'
import usePlausible from 'hooks/usePlausible'
import { useState } from 'react'
import { useHistory } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import chatApi from 'services/api/chat'

import { ReactComponent as MessageIcon } from './message.svg'

const SearchAndMessageGuest = ({ kind = 'direct' }) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false)

  const [isLoading, setIsLoading] = useState(false)

  const { addToast } = useToasts()

  const history = useHistory()

  function startNewChat({ guestFirstName, guestLastName, guestPhoneNumber }) {
    setIsLoading(true)
    chatApi
      .create({
        kind,
        guestFirstName,
        guestLastName,
        guestPhoneNumber
      })
      .then(({ chatId }) => {
        setIsLoading(false)
        setIsDialogVisible(false)
        history.push(`/${kind}/${chatId}`)
      })
      .catch(() => {
        setIsLoading(false)
        addToast('Error starting chat', { appearance: 'error', autoDismiss: true })
      })
  }

  function selectExistingChat(subscriberId) {
    setIsLoading(true)

    chatApi
      .start({ subscriberId, kind: 'Direct' })
      .then(res => {
        if (res.chatId) {
          history.push(`/${kind}/${res.chatId}`)
          setIsDialogVisible(false)
        }
      })
      .catch(err => {
        addToast(`${err}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const { postEvent, plausibleEvents } = usePlausible()

  function clickNewMessage() {
    postEvent(plausibleEvents.NewDirectMessage)

    setIsDialogVisible(true)
  }

  if (isLoading) {
    return (
      <Dialog>
        <div
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        ></div>
        <LoadingIndicator white />
      </Dialog>
    )
  }

  return (
    <div style={{ width: '100%', marginTop: 10 }}>
      <PrimaryRegularButton onClick={clickNewMessage} style={{ width: '100%' }}>
        <MessageIcon fill="white" style={{ marginRight: 4 }} width={18} height={18} />
        New message
      </PrimaryRegularButton>
      {isDialogVisible && (
        <SearchGuestDialog
          resultsTitle="Select a guest to message"
          onHideDialog={() => setIsDialogVisible(false)}
          onSelectGuest={selectExistingChat}
          onStartChat={startNewChat}
        />
      )}
    </div>
  )
}
export default SearchAndMessageGuest
